import { FC } from 'react'
import { Text } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'

interface Prop {
  regionName: string
  logistician?: {
    full_name: string
  }
  updated?: string
}

export const RegionCell: FC<Prop> = ({ regionName, logistician, updated }) => {
  const formatDate = useFormatDate()
  return (
    <>
      <Text typography="bodyMedium" color="primary">
        {regionName}
      </Text>
      {logistician && (
        <>
          <Text typography="bodySmall" color="secondary">
            {logistician.full_name}
          </Text>
          <Text typography="bodySmall" color="secondary">
            {updated ? formatDate(updated) : null}
          </Text>
        </>
      )}
    </>
  )
}
